import { data } from "react-phone-code";
import {
    GET_LICENSE_PURCHASE_PROPERTIES,LICENSE_PURCHASE_PROPERTIES,ADD_LICENSE_PURCHASE_PROPERTY,UPDATE_LICENSE_PURCHASE_PROPERTIY,DELETE_LICENSE_PURCHASE_PROPERTIY,SHOW_LOADING,HIDE_LOADING, 
    LICENSE_PURCHASE_PROPERTIES_MESSAGE, SET_ADD_EDIT, GET_LICENSE_PRCING_LIST, LICENSE_PRICING_LIST, ADD_LICENSE_PRICING, UPDATE_LICENSE_PRICING, DELETE_LICENSE_PRICING, GET_LICENSE_PRCING_VALUE_LIST,
     LICENSE_PRICING_VALUE_LIST, ADD_LICENSE_PRICING_VALUE, UPDATE_LICENSE_PRICING_VALUE, DELETE_LICENSE_PRICING_VALUE,LICENSE_PRICE_BACK,GET_LICENSE_PRCING_VALUE_LISTS
} from "redux/constants/licensePricing";


export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const hideLoading = () => {
  return {
    type: HIDE_LOADING,
  };
};

export const setAddEdit = (value) => {
  return {
    type: SET_ADD_EDIT,
    addEditValue: value,
  };
};

export const getLicensePurchaseProperties = (requestData) => {
  return {
    type: GET_LICENSE_PURCHASE_PROPERTIES,
    payload: requestData,
  };
};

export const licensePurchaseProperties = (data) => {
    return {
      type: LICENSE_PURCHASE_PROPERTIES,
      licensePurchaseProperties: data,
    };
  };

export const saveLicensePurchaseProperties = (data) => {
  return {
    type: ADD_LICENSE_PURCHASE_PROPERTY,
    payload: data,
  };
};

export const updateLicensePurchaseProperties = (data) => {
    return {
      type: UPDATE_LICENSE_PURCHASE_PROPERTIY,
      payload: data,
    };
  };

export const deleteLicensePurchaseProperties = (licensePurchaseProperties) => {
  return {
    type: DELETE_LICENSE_PURCHASE_PROPERTIY,
    payload: licensePurchaseProperties,
  };
};

export const getLicensePricingList = (requestData) => {
  return {
    type: GET_LICENSE_PRCING_LIST,
    payload: requestData,
  };
};

export const licensePricingList = (data) => {
    return {
      type: LICENSE_PRICING_LIST,
      licensePricingList: data,
    };
  };

export const saveLicensePricing = (data) => {
  return {
    type: ADD_LICENSE_PRICING,
    payload: data,
  };
};

export const updateLicensePricing = (data) => {
    return {
      type: UPDATE_LICENSE_PRICING,
      payload: data,
    };
  };

export const deleteLicensePrcing = (licensePurchaseProperties) => {
  return {
    type: DELETE_LICENSE_PRICING,
    payload: licensePurchaseProperties,
  };
};

export const getLicensePricingValues = (requestData) => {
  return {
    type: GET_LICENSE_PRCING_VALUE_LIST,
    payload: requestData,
  };
};

export const getLicensePricingValuesList = (requestData) => {
  return {
    type: GET_LICENSE_PRCING_VALUE_LISTS,
    payload: requestData,
  };
};

export const licensePricingValueList = (data) => {
    return {
      type: LICENSE_PRICING_VALUE_LIST,
      licensePricingValues: data,
    };
  };

export const saveLicensePricingValue = (data) => {
  return {
    type: ADD_LICENSE_PRICING_VALUE,
    payload: data,
  };
};

export const updateLicensePricingValue = (data) => {
    return {
      type: UPDATE_LICENSE_PRICING_VALUE,
      payload: data,
    };
  };

export const deleteLicensePricingValue = (licensePurchaseProperties) => {
  return {
    type: DELETE_LICENSE_PRICING_VALUE,
    payload: licensePurchaseProperties,
  };
};

export const showlicensePurchasePropertiesMessage=(data)=>{
    return {
      type : LICENSE_PURCHASE_PROPERTIES_MESSAGE,
      data:data
    }
}

export const back=()=>{
  return {
    type : LICENSE_PRICE_BACK,
  }
}

